import {
    useCallback,
    useEffect,
    useState
} from 'react';

import { storage } from '../../../../services/localstorage';
import { consoleLog } from '../../../../utils/log';

export const BACKUP_ERROR_STORAGE_KEY = 'backupError';
export const RESTORE_ERROR_STORAGE_KEY = 'restoreError';

export const getBackupError = async () => {
    return storage.getForProfile(BACKUP_ERROR_STORAGE_KEY, '');
};

export const setBackupError = async (error) => {
    consoleLog('setBackupError', error);
    return await storage.setForProfile(BACKUP_ERROR_STORAGE_KEY, error);
};

export const getRestoreError = async () => {
    return await storage.getForProfile(RESTORE_ERROR_STORAGE_KEY, '');
};
export const setRestoreError = async (error) => {
    return await storage.setForProfile(RESTORE_ERROR_STORAGE_KEY, error);
};

export const useBackupError = () => {
    const [ backupError, setBackupErrorState ] = useState('');
    const [ restoreError, setRestoreErrorState ] = useState('');

    const loadErrors = useCallback(async () => {
        try {
            const be = await getBackupError();
            const re = await getRestoreError();
            setBackupErrorState(be);
            setRestoreErrorState(re);
            console.log('useBackupError loadErrors - DONE');
        } catch (error) {
            consoleLog('useBackupError loadErrors error', error);
        }
    }, []);

    useEffect(() => {
        loadErrors();
    }, [ loadErrors ]);

    return {
        backupError,
        restoreError,
        reloadErrors: loadErrors,
    };
};
